import modalStyle from "../../../../../Common/Modals/modal.module.css";

import { X } from "lucide-react";

import { useEffect, useRef } from "react";

import NewPentestForm from "../../../../../Common/Forms/NewPentestForm/NewPentestForm.tsx";
import { ChangePentest, Pentest } from "../../../../../../sdkStructs.ts";

interface Props {
  data: Pentest;

  changePentest: (data: ChangePentest) => void;
  closeModal: () => void;
}

// !IMPORTANT: metadata usually refers to "contact information", other information is referred to as "pentest information"
function MetadataModal({ data, changePentest, closeModal }: Readonly<Props>) {
  useEffect(() => {
    const dialog = dialogRef?.current;
    if (dialog) {
      dialog.showModal();
      dialog.addEventListener("close", closeModal);
    }

    return () => {
      if (dialog) {
        dialog.removeEventListener("close", closeModal);
      }
    };
  }, [closeModal]);

  const dialogRef = useRef<HTMLDialogElement>(null);

  function submitPentestInfo(changes: Pentest) {
    changePentest({
      id: data.ID,
      title: changes.Title,
      //startDate: changes.StartDate,
      //endDate: changes.EndDate,
      category: changes.Category,
      type: changes.Type,
      client: changes.Client,
      scope: changes.Scope,
    });
    closeModal();
  }

  return (
    <dialog ref={dialogRef} className={modalStyle.metadataModalWrap + " " + modalStyle.modalStyle}>
      <div className={modalStyle.vulnRow}>
        <h2>Pentest Information</h2>
        <div className={modalStyle.modalCloseButton}>
          <X className={modalStyle.modalCloseIcon} stroke="white" strokeWidth="1.5" onClick={() => closeModal()} />
        </div>
      </div>
      <div className={modalStyle.formColumn + " " + modalStyle.extraMargin}>
        <NewPentestForm
          formDefault={{
            ID: data.ID,
            Title: data.Title,
            StartDate: data.StartDate.split('T')[0],
            EndDate: data.EndDate.split('T')[0],
            Category: data.Category,
            Type: data.Type,
            Client: data.Client,
            Scope: data.Scope,
          }}
          submit={submitPentestInfo}
        />
      </div>
    </dialog>
  );
}

export default MetadataModal;
